import React from "react";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { CustomerSearchModel } from "../../../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchModel";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { Prospect } from "../../../../../../../Wrap/Models/Models/Customer/Prospect";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { NewBusinessAction } from "../../../NewBusinessWizard/Actions/NewBusinessAction";
import { AdviserDetail } from "../../../NewBusinessWizard/Components/FullClientDetail/AdviserDetail";
import { ClientDetail as FullClientDetail } from "../../../NewBusinessWizard/Components/FullClientDetail/ClientDetail";
import { ContactDetail as FullContactDetail } from "../../../NewBusinessWizard/Components/FullClientDetail/ContactDetail";
import { TaxDetail } from "../../../NewBusinessWizard/Components/FullClientDetail/TaxDetail";
import { NBSteppers } from "../../../NewBusinessWizard/Resource/Contents";
import { AdviserContextStoreStatic, CustomerContextStoreStatic } from "../../../NewBusinessWizard/Stores/Variable";
import { CustomerMatchingAction } from "../../Actions/CustomerMatchingAction";
import { ClientDetail } from "../ClientDetails/ClientDetail";
import { ContactDetail } from "../ClientDetails/ContactDetail";
import { CustomerMatching } from "../CustomerMatching/CustomertMatching";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { FullClientDetailHelper } from "../../../Common/FullClientDetail/FullClientDetailHelper";
import { AccountRoleActorCategory } from "../../../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { CustomerStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { EmailAddressType } from "../../../../../../../Wrap/Constants/Enums/EmailAddressType";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { Title } from "../../../../../../../Wrap/Constants/Enums/Title";

interface IAddFullClientProps extends IProcessComponentProps {
    data: FullClientDetailModel;
    customerId: number;
    existingCustomer: boolean;
    ownerAdviserId: number;
    onSetAdditionalDetails: (customerId, existingCustomer) => void;
    onCustomerIdChange(customerId): void;
}

interface IAddFullClientState {
    data: Prospect;
    isCustomerMatchingOpen: boolean;
    customerMatchingResult: CustomerSearchModel;
    isLoading: boolean;
    AdvisorName: string;
    existingClientInfo: FullClientDetailModel;
    showFullClientDetails: boolean;
}

export class AddFullClient extends ProcessComponent<IAddFullClientProps, IAddFullClientState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: {},
            isCustomerMatchingOpen: false,
            customerMatchingResult: null,
            isLoading: false,
            AdvisorName: null,
            existingClientInfo: null,
            showFullClientDetails: props?.data != null,
        };
        this.subscribeToStore(AdviserContextStoreStatic, () => this.onAdviserContextStoreChange());
        this.subscribeToStore(CustomerContextStoreStatic, () => this.onCustomerContextStoreChange());
    }

    onCustomerContextStoreChange(): void {
        this.loadCustomerFromStore();
        this.onAdviserContextStoreChange();

        let initArray = [];
        
        initArray = FullClientDetailHelper.updatePostalAddress(initArray, this.props.data);
        this.onFullClientChange(initArray);
    }

    componentDidMount() {
        super.componentDidMount();
        this.onCCMChange({ OwnerAdviserId: this.props.ownerAdviserId });
        if (this.props.customerId) {
            NewBusinessAction.getCustomerData(this.props.customerId);
        } else if (this.props.ownerAdviserId) {
            NewBusinessAction.getAdviserDetail(
                HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Advisor, this.props.ownerAdviserId)
            );
        }
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (prevProps.customerId != this.props.customerId && this.props.customerId != null) {
            this.setState({ isLoading: true });
            this.props.onChange(null);
            NewBusinessAction.getCustomerData(this.props.customerId);
        }
        if (prevProps.existingCustomer != this.props.existingCustomer) {
            this.setState({ showFullClientDetails: this.props.existingCustomer });
        }
    }

    onAdviserContextStoreChange(): void {
        const adv = AdviserContextStoreStatic.getData();
        if (adv) {
            this.setState({
                AdvisorName: adv?.Name,
            });
        }
    }

    loadCustomerFromStore(): void {
        const val = CustomerContextStoreStatic.getData();
        if (this.props.data == null) {
            this.props.onChange(val);
        }
        this.setState({
            isLoading: false,
            existingClientInfo: val,
        });
    }

    isValid() {
        return super.isValid() && (!this.props.data || this.checkValidation(this.props.data));
    }

    checkValidation(model: FullClientDetailModel) {
        const { isValid, errorMsg } = FullClientDetailHelper.fullClientDetailValidation(model);
        if (errorMsg.length > 0) {
            this.props.showErrorMsgPopUp(errorMsg, true);
        }
        return isValid;
    }

    private getCustomerMatchingData(pageIndex, pageSize) {
        const flag = this.isValid();
        if (flag) {
            const { ownerAdviserId } = this.props;
            const { data } = this.state;
            CustomerMatchingAction.getMatchingCustomers(
                data?.FirstName,
                data?.Surname,
                data?.DateOfBirth,
                ownerAdviserId,
                pageIndex,
                pageSize,
                (result: CustomerSearchModel) => {
                    if (result.CustomerList && result.CustomerList?.length > 0) {
                        this.setState({ isCustomerMatchingOpen: true, customerMatchingResult: result });
                    } else {
                        this.populateFullClientDetailsFromProspect();
                    }
                }
            );
        }
    }

    private populateFullClientDetailsFromProspect() {
        const { data } = this.state;
        let model: FullClientDetailModel = {
            ActorOwnerId: data?.OwnerAdviserId,
            ActorId: null,
            ActorCategory: AccountRoleActorCategory.Customer,
            PersonalDetails: {
                Title: TitleMap.getEnum(data?.Title),
                GivenName: data?.FirstName,
                MiddleName: data?.MiddleName,
                FamilyName: data?.Surname,
                CustomerStatus: CustomerStatus.Active,
                Gender: data?.Gender,
                DateOfBirth: data?.DateOfBirth,
            },
            EmailAddressDetails: [{ EmailAddress: data?.EmailAddress, EmailAddressType: EmailAddressType.Primary }],
            PhoneNumberDetails: data?.PhoneNumbers,
            AddressDetails: [],
        };

        let initArray = [];
        initArray = FullClientDetailHelper.initTaxModel(initArray, model);
        initArray = FullClientDetailHelper.updatePostalAddress(initArray, model);
        model = this.setValue(model, initArray);
        this.props.onChange(model);
        this.setState({ showFullClientDetails: true });
    }

    private onPageChange(pageIndex, pageSize) {
        this.getCustomerMatchingData(pageIndex, pageSize);
    }

    private onDismissCustomerMatchings() {
        this.populateFullClientDetailsFromProspect();
    }

    private setValue = (data, changes: { value: any; path: string }[]) => {
        let _model = { ...data };
        changes.forEach((change) => {
            _model = setValueByKey(_model, change.path, change.value);
        });
        return _model;
    };

    private onFullClientChange = (changes: { value: any; path: string }[]) => {
        const { data } = this.props;

        this.props.onChange(this.setValue(data, changes));
        //console.log(_model);
    };

    private onCCMChange = (changes) => {
        const { data } = this.state;
        if (data.Title == null) {
            data.Title = TitleMap.getString(Title.Miss);
        }
        const _data = JSON.parse(JSON.stringify(data));
        for (const key in changes) {
            _data[key] = JSON.parse(JSON.stringify(changes[key]));
        }
        this.props.showErrorMsgPopUp([], false);
        this.setState({ data: _data });
    };

    private renderAddBasicDetails() {
        const { data } = this.state;
        return (
            <>
                <ClientDetail
                    data={data ? data : {}}
                    onChange={(changes) => {
                        this.onCCMChange(changes);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                />
                <ContactDetail
                    data={data ? data : {}}
                    onChange={(changes) => {
                        this.onCCMChange(changes);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                />
                <button type="button" className="btn secondary" onClick={() => this.getCustomerMatchingData(1, 10)}>
                    Additional client details
                </button>
                {this.state.isCustomerMatchingOpen && (
                    <Lightbox
                        show={this.state.isCustomerMatchingOpen}
                        title={"Client matches"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ isCustomerMatchingOpen: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <CustomerMatching
                            data={this.state.customerMatchingResult}
                            onPageChange={(pageIndex, pageSize) => this.onPageChange(pageIndex, pageSize)}
                            onDismissMatches={() => this.onDismissCustomerMatchings()}
                            displayChooseClientOption={true}
                            onClientChosen={(customerId) => this.props.onSetAdditionalDetails(customerId, true)}
                        ></CustomerMatching>
                    </Lightbox>
                )}
            </>
        );
    }

    private renderFullClientDetails() {
        if (this.state.isLoading || !this.props.data) {
            return <PartLoading />;
        }
        return (
            <>
                <h2>{NBSteppers.fullClientDetail}</h2>
                <AdviserDetail
                    data={this.state.AdvisorName}
                    onChange={() => {}}
                    onAdviserChange={null}
                    onRef={(ref) => this.appendChild(ref)}
                />

                <FullClientDetail
                    data={this.props.data}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onFullClientChange(changes);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={false}
                    existingClientInfo={this.state.existingClientInfo}
                    index={1}
                />

                <FullContactDetail
                    data={this.props.data}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onFullClientChange(changes);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={false}
                    existingClientInfo={this.state.existingClientInfo}
                    onCorrespondenceAddressChange={() => {}}
                />

                <TaxDetail
                    data={this.props.data}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onFullClientChange(changes);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={false}
                    existingClientInfo={this.state.existingClientInfo}
                />
            </>
        );
    }

    public render(): JSX.Element {
        const { data, ownerAdviserId, customerId } = this.props;
        if (this.props.existingCustomer == null) {
            return <></>;
        }
        if (customerId != null || this.state.showFullClientDetails) {
            return this.renderFullClientDetails();
        } else {
            return this.renderAddBasicDetails();
        }
    }
}
